import { cn } from "../../lib/utils";

/**
 * Currency Display Component
 * Formats and displays currency values with customizable styling
 */
export const CurrencyDisplay = ({ 
  amount, 
  size = "default", 
  showSign = false,
  type = "neutral",
  className 
}) => {
  const formattedAmount = Math.abs(amount).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const sizeClasses = {
    sm: "text-lg",
    default: "text-2xl",
    lg: "text-3xl",
    xl: "text-4xl",
    "2xl": "text-5xl"
  };

  const typeClasses = {
    neutral: "text-slate-800",
    deposit: "text-green-600",
    withdrawal: "text-red-600",
    pending: "text-amber-600"
  };

  const sign = showSign ? (amount >= 0 ? '+' : '-') : '';

  return (
    <span 
      className={cn(
        "font-bold tabular-nums",
        sizeClasses[size],
        typeClasses[type],
        className
      )}
      data-testid="currency-display"
    >
      {sign}${formattedAmount}
    </span>
  );
};

/**
 * Currency Input Component
 * Formatted input for currency values
 */
export const CurrencyInput = ({ value, onChange, placeholder = "0.00", className, ...props }) => {
  const handleChange = (e) => {
    const val = e.target.value.replace(/[^0-9.]/g, '');
    // Only allow one decimal point and two decimal places
    if (val.split('.').length > 2) return;
    if (val.includes('.') && val.split('.')[1]?.length > 2) return;
    onChange(val);
  };

  return (
    <div className={cn("relative", className)}>
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 font-medium">$</span>
      <input
        type="text"
        inputMode="decimal"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className="w-full pl-7 pr-4 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 text-lg"
        data-testid="currency-input"
        {...props}
      />
    </div>
  );
};
